export type AesStandDataResult =
  | 'success'
  | 'timeouted'
  | 'readFirstReaderOnly'
  | 'readSecondReaderOnly'
  | 'preClosedReadBothReaderFailed'
  | 'preClosedReadFirstReaderOnly'
  | 'irregular'

export const AES_RESPONSE_CODE = {
  success: '00',
  timeouted: '01',
  readFirstReaderOnly: '02',
  readSecondReaderOnly: '03',
  preClosedReadBothReaderFailed: '04',
  preClosedReadFirstReaderOnly: '05',
} as const

export function convertStringToStandResponseResult(
  raw: string
): AesStandDataResult {
  switch (raw) {
    case AES_RESPONSE_CODE.success:
      return 'success'
    case AES_RESPONSE_CODE.timeouted:
      return 'timeouted'
    case AES_RESPONSE_CODE.readFirstReaderOnly:
      return 'readFirstReaderOnly'
    case AES_RESPONSE_CODE.readSecondReaderOnly:
      return 'readSecondReaderOnly'
    case AES_RESPONSE_CODE.preClosedReadBothReaderFailed:
      return 'preClosedReadBothReaderFailed'
    case AES_RESPONSE_CODE.preClosedReadFirstReaderOnly:
      return 'preClosedReadFirstReaderOnly'
    default:
      return 'irregular'
  }
}

// AES コマンドコード（legacy: 0x04/0x05、modern: 0x0d、電池: 0x08）
export const AesCommand = {
  rentalLegacy: 0x04,
  returnLegacy: 0x05,
  modern: 0x0d,
  readPower: 0x08,
} as const
